import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface PayerPolicy {
  id: string;
  state: string;
  payer_name: string;
  payer_type: string;
  cpt_code: string;
  cpt_description: string;
  pa_required: 'Yes' | 'No' | 'Conditional' | 'Unknown';
  pa_rules_summary: string | null;
  documentation_requirements: Record<string, string | boolean>;
  submission_channels: Array<{ channel: string; link: string }>;
  source_url: string | null;
  effective_date: string;
  confidence: string;
  is_next_gen_medicaid: boolean;
}

export function usePayerPolicies() {
  const [policies, setPolicies] = useState<PayerPolicy[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [showNextGen, setShowNextGen] = useState(false);

  useEffect(() => {
    fetchPolicies();
  }, [showNextGen]);

  const fetchPolicies = async () => {
    setLoading(true);
    let query = supabase
      .from('payer_policies')
      .select('*')
      .order('payer_name');

    if (!showNextGen) {
      query = query.eq('is_next_gen_medicaid', false);
    }

    const { data, error } = await query;
    if (!error && data) {
      setPolicies(data as unknown as PayerPolicy[]);
    }
    setLoading(false);
  };

  const filteredPolicies = policies.filter(p => {
    if (!searchQuery.trim()) return true;
    const q = searchQuery.toLowerCase();
    return (
      p.cpt_code.includes(q) ||
      p.payer_name.toLowerCase().includes(q) ||
      p.cpt_description.toLowerCase().includes(q)
    );
  });

  return {
    policies: filteredPolicies,
    allPolicies: policies,
    loading,
    searchQuery,
    setSearchQuery,
    showNextGen,
    setShowNextGen,
  };
}
